import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';

import { FormFocusableService } from '@ts/shared/form/focus/util-core';

import { IonFormFieldFocusableWrapperAbstractUiComponent } from '../ion-form-field-focusable-wrapper-abstract-ui/ion-form-field-focusable-wrapper-abstract-ui.component';

// TODO(irvan): The HTML logic is duplicated with ion-form-field-wrapper-ui
// Hard to decouple because both extends FieldWrapper.
@Component({
  selector: 'ts-ion-form-field-labeled-wrapper-ui',
  templateUrl: './ion-form-field-labeled-wrapper-ui.component.html',
  styleUrls: ['./ion-form-field-labeled-wrapper-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IonFormFieldLabeledWrapperUiComponent extends IonFormFieldFocusableWrapperAbstractUiComponent {
  protected formFocusableService = inject(FormFocusableService);

  @ViewChild('scrollHereOnFocus') scrollHereOnFocus!: ElementRef;
}
